import { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { LayoutDashboard, FileText, Settings } from "lucide-react";
import { cn } from "@/lib/utils";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

interface AdminLayoutProps {
  children: ReactNode;
}

const AdminLayout = ({ children }: AdminLayoutProps) => {
  const menuItems = [
    {
      title: "Dashboard",
      href: "/admin/dashboard",
      icon: LayoutDashboard,
    },
    {
      title: "Blog-Verwaltung",
      href: "/admin/blog",
      icon: FileText,
    },
    {
      title: "SEO Validierung",
      href: "/admin/seo-validierung",
      icon: Settings,
    },
    {
      title: "Einstellungen",
      href: "/admin/einstellungen",
      icon: Settings,
    },
  ];

  return (
    <div className="min-h-screen relative">
      
      <div className="relative z-10">
        <Navigation />
        
        {/* Admin Navigation Bar */}
        <div className="border-b border-border/40 bg-card/30 backdrop-blur-sm">
          <div className="container mx-auto px-4">
            <nav className="flex items-center gap-1 py-3">
              <span className="text-sm font-medium text-muted-foreground mr-4">
                Admin-Bereich
              </span>
              {menuItems.map((item) => (
                <NavLink
                  key={item.href}
                  to={item.href}
                  className={({ isActive }) =>
                    cn(
                      "flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-colors",
                      isActive
                        ? "bg-primary/10 text-primary"
                        : "text-muted-foreground hover:bg-muted/50 hover:text-foreground"
                    )
                  }
                >
                  <item.icon className="w-4 h-4" />
                  {item.title}
                </NavLink>
              ))}
            </nav>
          </div>
        </div>

        {/* Content */}
        <main className="container mx-auto px-4 py-8">
          {children}
        </main>
        
        <Footer />
      </div>
    </div>
  );
};

export default AdminLayout;
